import React, { PropsWithChildren } from 'react';

import Corner from './assets/corner.svg';
import useStyles from './styles';

interface Props {
    options: {
        label: string;
        value: string;
    }[];
    value: string;
    onChange: (value: string) => void;
    className?: string;
}

const Tabs: React.FC<PropsWithChildren<Props>> = ({ options, children, value, onChange, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.bar}>
                {options.map((option, index) => {
                    const isActive = option.value === value;
                    return (
                        <div
                            key={option.value}
                            onClick={() => onChange(option.value)}
                            className={cx(classes.item, { [classes._active]: isActive })}
                        >
                            {isActive && index > 0 ? (
                                <Corner className={cx(classes.corner, classes._bottomLeft)} />
                            ) : null}
                            {option.label}
                            {isActive ? <Corner className={cx(classes.corner, classes._bottomRight)} /> : null}
                        </div>
                    );
                })}
            </div>
            {children}
        </div>
    );
};

export default Tabs;
